/* ==========================================================================
   Solid Viibe — global behaviour
   Stagger delays + scroll reveal. Vanilla, no framework, no build step.
   Ported from the approved prototype's sv-common.js.
   ========================================================================== */
(function () {
  'use strict';

  /* --- Stagger ---------------------------------------------------------
     Any [data-stagger] container hands its direct children an incremental
     --d delay and marks them as reveal targets, so no delay is ever written
     by hand in a section file. data-stagger="120" overrides the step in ms. */
  function stagger(scope) {
    scope.querySelectorAll('[data-stagger]').forEach(function (container) {
      var step = parseInt(container.dataset.stagger, 10) || 80;
      Array.prototype.forEach.call(container.children, function (child, i) {
        child.style.setProperty('--d', (i * step) + 'ms');
        if (!child.classList.contains('sv-rise') && !child.classList.contains('sv-pop')) {
          child.classList.add('sv-reveal');
        }
      });
    });
  }

  /* --- Reveal on scroll ------------------------------------------------
     Two kinds of target share one observer: .sv-reveal elements, which carry
     their own enter transition, and [data-anim] containers, which only need
     the is-in flag so a CSS animation inside them can fire. */
  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  }

  function reveal(scope) {
    var targets = scope.querySelectorAll('.sv-reveal, [data-anim]');
    if (io) {
      targets.forEach(function (el) { io.observe(el); });
    } else {
      targets.forEach(function (el) { el.classList.add('is-in'); });
    }
  }

  function init(scope) {
    stagger(scope);
    reveal(scope);
  }

  init(document);

  /* Theme editor: sections are re-rendered without a page load. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  window.SolidViibe = window.SolidViibe || {};
  window.SolidViibe.initMotionTargets = init;

  /* --- Money formatting -------------------------------------------------
     Cart JS renders prices client side. Shopify hands us cents; the store is
     CAD and prices are shown before tax, so we only ever need one format.
     Ontario charges HST, which Shopify adds at checkout — this formatter must
     never try to compute or display it. */
  window.SolidViibe.formatMoney = function (cents) {
    return '$' + (Math.round(cents) / 100).toFixed(2);
  };
})();
